'use client';

import { AnimatedSection } from '@/components/client/landing/AnimatedSection';
import { SportsbookStrip } from '@/components/client/landing/SportsbookStrip';
import { ProjectionsShowcase } from '@/components/client/landing/ProjectionsShowcase';
import {
  NBAResearchRow,
  PitcherResearchRow,
  MobileResearchRow,
} from '@/components/client/landing/LandingResearchRows';

/**
 * Below-the-fold product story shared by the landing page and /pricing. Order is
 * deliberate: projections lead, research rows support. The negative top margin
 * trims the showcase's padding so it doesn't double up with the sportsbook band.
 */
export function MarketingFeed() {
  return (
    <>
      {/* Wrap from out here — the strip owns an internal ref for marquee gating. */}
      <AnimatedSection className="border-y border-border/40 dark:border-border-primary/40">
        <SportsbookStrip />
      </AnimatedSection>
      <div className="-mt-4 md:-mt-10">
        <ProjectionsShowcase />
      </div>
      <NBAResearchRow />
      <PitcherResearchRow />
      <MobileResearchRow />
    </>
  );
}
